document.addEventListener("DOMContentLoaded", () => {
  document.body.addEventListener("click", (event) => {
    const button = event.target.closest(".open_location_details");
    if (!button) return;

    event.preventDefault();

    const details = button.previousElementSibling;
    if (!details || !details.classList.contains("contact-location-details"))
      return;

    // Ensure initial display state is set
    if (!details.style.display) {
      details.style.display = details.classList.contains("show_details")
        ? "block"
        : "none";
    }

    // Toggle visibility and class
    const isOpen = !details.classList.contains("show_details");
    details.classList.toggle("show_details", isOpen);
    details.style.display = isOpen ? "block" : "none";
    button.classList.toggle("details_open", isOpen);
    details
      .closest(".contact-location-details_wrap")
      ?.classList.toggle("loc_expanded", isOpen);

    // Toggle button text
    const label = button.querySelector(".open-details-label");
    if (label) {
      label.textContent = isOpen ? "Hide Details" : "Show Details";
    }
  });

  document.body.addEventListener("click", (event) => {
    const trigger = event.target.closest(".map_popup_trigger");
    const closeButton = event.target.closest(".map_close");
    const proxyTrigger = event.target.closest(".map_trigger_proxy");
    const mapPopup = document.querySelector(".map_popup");

    if (trigger) {
      event.preventDefault();
      const gmap = trigger.getAttribute("data-gmap");
      const amap = trigger.getAttribute("data-amap");

      if (mapPopup) {
        mapPopup.classList.toggle("visible");
        mapPopup.style.display = mapPopup.classList.contains("visible")
          ? "block"
          : "none";
      }
      document.body.classList.toggle("popup_open");

      if (gmap) document.getElementById("gmap")?.setAttribute("href", gmap);
      if (amap) document.getElementById("amap")?.setAttribute("href", amap);
    }

    if (closeButton) {
      if (mapPopup) {
        mapPopup.classList.remove("visible");
        mapPopup.style.display = "none";
      }
      document.body.classList.remove("popup_open");
    }

    if (proxyTrigger) {
      event.preventDefault();
      const target = proxyTrigger.getAttribute("data-for");
      const targetTrigger = document.querySelector(
        `.map_popup_trigger[data-for="${target}"]`
      );

      if (targetTrigger) {
        targetTrigger.dispatchEvent(
          new Event("click", { bubbles: true, cancelable: true })
        );
      }
    }
  });
});
